import { Component, EventEmitter, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { CoverFaqComponent } from '../cover-faq/cover-faq.component';
import { AuthService } from 'src/services/auth/auth.service';
import { CommonModule } from '@angular/common';
import { environment } from 'src/environments/environment';
import {
  AnalyticsLoggerService,
  GENERAL_EVENTS,
} from 'src/app/services/analytics-logger.service';
import { CoverNewsletterComponent } from '../cover-newsletter/cover-newsletter.component';

@Component({
  selector: 'cover-hero',
  standalone: true,
  imports: [
    MatIconModule,
    MatExpansionModule,
    CoverFaqComponent,
    CommonModule,
    CoverNewsletterComponent,
  ],
  templateUrl: './cover-hero.component.html',
  styleUrl: './cover-hero.component.scss',
})
export class CoverHeroComponent {
  public environment = environment;

  constructor(
    public authService: AuthService,
    private analyticsLogger: AnalyticsLoggerService
  ) {}

  @Output() public onCloseClick = new EventEmitter();
  @Output() public onSignupClick = new EventEmitter();
  @Output() public onLoginClick = new EventEmitter();

  tryDemo() {
    this.onCloseClick.emit();
  }
}
